import { render } from "./GoodItem.vue?vue&type=template&id=19bf50f8&scoped=true"
import script from "./GoodItem.vue?vue&type=script&lang=ts"
export * from "./GoodItem.vue?vue&type=script&lang=ts"

import "./GoodItem.vue?vue&type=style&index=0&id=19bf50f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19bf50f8"

export default script